import type { AccessProfileByIdDataProps, ProfileItemProps } from '@pages/AccessProfile/context/types'
import type { AccessProfileModalFormProps } from './types'

export const setInitialValues = (data: ProfileItemProps | null, permissionsData: AccessProfileByIdDataProps | null) => {
  const formData: AccessProfileModalFormProps = {
    profileDescription: data?.name || '',
    profileType: data?.type || '',
    status: data?.isActive ? 'Ativo' : 'Inativo',
    observations: data?.observations || '',
    fullAccess: permissionsData?.hasFullModuleAccess || false
  }

  return formData
}
